import CarouselDots from '../CarouselDots';

import styles from './ImageCarouselDots.module.scss';

const MAX_DOTS = 7;

const ImageCarouselDots = ({ nItems, onDotClick, selectedItem }) => (
  <CarouselDots
    nItems={nItems}
    onDotClick={onDotClick}
    selectedItem={selectedItem}
    className={styles['image-carousel-dots']}
    maxDots={MAX_DOTS}
  />
);

export default ImageCarouselDots;
